export function createPreset<D extends string, T extends string, U extends string>(
  preset: Array<D> | Partial<Record<D, Array<T>>>,
  hosts: U[],
): Partial<Record<D, Array<T | U>>> {
  if (Array.isArray(preset)) {
    if (preset.length === 0) {
      throw new Error('hosts array is empty')
    }
    return preset.reduce(
      (acc, directive) => {
        acc[directive] = hosts
        return acc
      },
      {} as Partial<Record<D, Array<T | U>>>,
    )
  }
  return Object.keys(preset).reduce(
    (acc, directive) => {
      acc[directive] = [...acc[directive], ...hosts]
      return acc
    },
    {} as Partial<Record<D, Array<T | U>>>,
  )
}
